interface LogoProps {
  className?: string
  showText?: boolean
}

export default function Logo({ className = '', showText = false }: LogoProps) {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Fired Up Games Logo */}
      <div className="relative">
        <img
          src="https://fugimagestorage.blob.core.windows.net/fug-images/small_logo_clear.png"
          alt="Fired Up Games"
          className="object-contain"
          style={{ width: '180px', height: '180px', marginTop: '20px', marginLeft: '-10px' }}
        />
      </div>

      {showText && (
        <div className="flex flex-col">
          <span className="logo-text leading-none">FIRED UP</span>
          <span className="text-xs text-gray-400 font-normal tracking-wider">GAMES</span>
        </div>
      )}
    </div>
  )
}
